import styled from 'styled-components'

export const MainHeader = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-around;
  gap: 15px;

  @media (max-width: 768px) {
    justify-content: flex-start;
    overflow-x: auto;
    padding-bottom: 10px;

    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
`

export const ContentHeader = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-around;

  .content {
    display: flex;
    align-items: center;
    font-family: 'Montserrat', sans-serif;
    gap: 10px;

    label {
      font-style: italic;
      font-weight: 700;
    }

    p {
      font-style: italic;
    }

    .warn {
      color: #ff0000;
    }
    .alert {
      color: #e69138;
    }
    .check {
      color: #c96800;
    }
    .check-green {
      color: #43c000;
    }

    .warn-label {
      color: #ffffff;
      background-color: #ff0000;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 10px;
      border-radius: 50000px;
      font-size: 30px;
    }
    .alert-label {
      background-color: #e69138;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 10px;
      border-radius: 50000px;
      font-size: 30px;
    }
    .check-label {
      background-color: #c96800;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 10px;
      border-radius: 50000px;
      font-size: 30px;
    }
    .check-green-label {
      background-color: #43c000;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 10px;
      border-radius: 50000px;
      font-size: 30px;
    }

    img {
      border-radius: 500px;
      box-shadow: 0px 2px 2px 1px rgba(0, 0, 0, 0.2);
    }
  }

  @media (max-width: 1400px) {
    .content {
      padding: 10px 0 0 30px;
      display: flex;
      align-items: center;
      font-family: 'Montserrat', sans-serif;
      gap: 30px;
      width: 100%;

      label {
        font-size: 15px;
        font-style: italic;
        font-weight: 700;
      }
      p {
        font-size: 10px;
        font-style: italic;
      }
      img {
        width: 28px;
        border-radius: 500px;
        box-shadow: 0px 2px 2px 1px rgba(0, 0, 0, 0.2);
      }
    }
  }

  @media (max-width: 768px) {
    flex-shrink: 0;
    width: 260px;

    .content {
      padding: 10px;
      gap: 15px;
    }
  }
`
